import { eventDispatcherConfig } from './AppOobeValuePropPage.analytics'

import { PageSuffix } from '@/constants/errors/suffix'
import { registerPage } from '@/utils/register-page'

export const AppOobeContract = registerPage({
  suffix: PageSuffix.APP_VALUE_PROP,
  shouldRenderFactory: () => import('./helpers/should-render'),
  pageFactory: () => import('./AppOobeValuePropPage'),
  analyticsConfig: () => eventDispatcherConfig().config,
})
